import { styled } from 'styled-components'

export const Root = styled.h1`
  color: #35424A;
  font-weight: bold;
  font-size: 32px;
  margin: 0;
  margin-bottom: 30px;
`
